module.exports = __webpack_public_path__ + "static/media/arrow-left2.8ea9f747.svg";


//////////////////
// WEBPACK FOOTER
// ./src/content/chapters/05/02/assets/arrow-left2.svg
// module id = 555
// module chunks = 0